import { configureStore } from '@reduxjs/toolkit'
import projectReducer from './slice/projectSlice'

export default configureStore({
  reducer: {
    projectSite: projectReducer
  }
})
